import React, { useState, useEffect, Fragment } from "react";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import sliderbgImg from "../../assets/images/slider-bg.png";
import tacoriImg from "../../assets/images/tacori-logo.png";
import hoverBg1 from "../../assets/images/daimond-bg.png";
import hoverBg2 from "../../assets/images/jewelry-bg.png";
import hoverBg3 from "../../assets/images/watch-bg.png";
import hoverBg4 from "../../assets/images/gemstone-bg.png"
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import catalogJewelryService from "../../services/catalog-jewelry.service";
import communityVendorService from "../../services/community-vendor.service";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { NotificationManager } from "react-notifications";
import { Link } from "react-router-dom";
import CustomCarousel from "./carousal/Carousal";
import AnimatedNumber from "../dashboard/AnimatedNumber";
import {
  Button,
  Checkbox,
  Input,
  Modal,
  Space,
  Spin,
  Switch,
  Table,
  Tooltip,
} from "antd";

const CatlogList = () => {
  const { t } = useTranslation();
  const loginDetials = useSelector((state) => state.loginReducer);
  const headerDetials = useSelector((state) => state.headerMenuReducer);
  const [countData, setCountData] = useState({});
  const [loading, setLoading] = useState(false);
  const [isDiamondShow, setIsDiamondShow] = useState(false);
  const [isJewelaryShow, setIsJewelaryShow] = useState(false);
  const [isWatchShow, setIsWatchShow] = useState(false);
  const [recentlyUpdatedVendorData, setRecentlyUpdatedVendorData] = useState(
    []
  );
  const [vendorLoading, setVendorLoading] = useState(false);
  const [isModalSendInvitationVisible, setIsModalSendInvitationVisible] =
    useState(false);
  const [row, setRow] = useState([]);
  const [checkbox, setCheckBox] = useState("");
  const [page, setPage] = useState("RetailerAffirmation");
  const [disableBtn, setDisableBtn] = useState(true);
  const [content, setContent] = useState("");
  const [emailLoading, setEmailLoading] = useState(false);
  const [dealerId, setDealerId] = useState("");
  const [dealerCompany, setDealerCompany] = useState("");
  const [isColorStoneShow, setIsColorStoneShow] = useState(false);
  const category = [
    {
      label: "Current Authorized Reseller",
      value: "CurrentAuthorizedReseller",
      note: (
        <>
          {t(
            "By checking this box and clicking the submit button below Ihere by affirm that"
          )}
          {dealerCompany ? dealerCompany : null}
          {t("has an open and active account with")}
          {row.dealerCompany}
          {t(",that I am an authorized reseller of")}
          {row.dealerCompany}
          {t(
            ",and that I am permitted to have the ir virtual inventory on my website."
          )}
        </>
      ),
    },
    {
      label: "New Account Request",
      value: "NewAccountRequest",
      note: (
        <>
          {t("I am interested in opening a new account with")}{" "}
          {row.dealerCompany}
          {t(
            "and becoming an authorized reseller.By checking this box and clicking the submit button below, your name and store information will be sent to"
          )}
          {row.dealerCompany}.
        </>
      ),
    },
  ];

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerCompany(
            loginDetials.loginDetials.responseData.dealerCompany
          );
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleGetCatalogCount(
            loginDetials.loginDetials.responseData.dealerId
          );
          handleAdminDashBoardBindDataCommVendor(
            loginDetials.loginDetials.responseData.dealerId,
            0
          );
        }
      }
    }
  }, []);

  // Dimaond and Jewelery

  useEffect(() => {
    if (headerDetials.sideMenuTierThreeDetails) {
      for (var i = 0; i < headerDetials.sideMenuTierThreeDetails.length; i++) {
        if (
          headerDetials.sideMenuTierThreeDetails[i].twoTierPageName ==
            "Products" &&
          headerDetials.sideMenuTierThreeDetails[i].threeTierPageName ==
            "Diamond"
        ) {
          setIsDiamondShow(true);
        }
        if (
          headerDetials.sideMenuTierThreeDetails[i].twoTierPageName ==
            "Products" &&
          headerDetials.sideMenuTierThreeDetails[i].threeTierPageName ==
            "Jewelry"
        ) {
          setIsJewelaryShow(true);
        }
        if (
          headerDetials.sideMenuTierThreeDetails[i].twoTierPageName ==
            "Products" &&
          headerDetials.sideMenuTierThreeDetails[i].threeTierPageName ==
            "Watches"
        ) {
          setIsWatchShow(true);
        }
        if (
          headerDetials.sideMenuTierThreeDetails[i].twoTierPageName ==
            "Products" &&
          headerDetials.sideMenuTierThreeDetails[i].threeTierPageName ==
            "Gemstone"
        ) {
          setIsColorStoneShow(true);
        }
      }
      // if (
      //   element.twoTierPageName == "Products" &&
      //   element.threeTierPageName == "Diamond"
      // ) {
      //   setIsDiamondShow(true);
      // } else {
      //   setIsDiamondShow(false);
      // }
      // if (
      //   element.twoTierPageName == "Products" &&
      //   element.threeTierPageName == "Jewelry"
      // ) {
      //   setIsJewelaryShow(true);
      // } else {
      //   setIsDiamondShow(false);
      // }
      // if (
      //   element.twoTierPageName == "Products" &&
      //   element.threeTierPageName == "Watches"
      // ) {
      //   setIsWatchShow(true);
      // } else {
      //   setIsWatchShow(false);
      // }
    }
  }, [headerDetials]);

  const handleAdminDashBoardBindDataCommVendor = async (id) => {
    try {
      let inputData = {
        dealerID: id.toString(),
        filerType: "3",
        currentPage: 1,
        recordOnPage: 15,
        searchKeyChar: "",
        searchType: "",
        sortColumnName: "dealerCompany",
        sortOrder: "asc",
        lstColumnFilter: [],
        limitcount: 0,
      };
      setVendorLoading(true);
      communityVendorService
        .AdminDashBoardBindDataCommVendor(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData.vendor_NetworkResponse.length > 0) {
              setRecentlyUpdatedVendorData(responseData.vendor_NetworkResponse);
              setVendorLoading(false);
            } else {
              setRecentlyUpdatedVendorData([]);
              setVendorLoading(false);
            }
          } else {
            setRecentlyUpdatedVendorData([]);
            setVendorLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setVendorLoading(false);
        });
    } catch (error) {
      console.log(error);
      setVendorLoading(false);
    }
  };

  const handleGetCatalogCount = (Id) => {
    try {
      let inputData = {
        dealerId: Number(Id),
      };
      setLoading(true);
      catalogJewelryService
        .GetCatalogCount(inputData)
        .then((response) => {
          setLoading(false);
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setCountData(responseData);
            setLoading(false);
          } else {
            setCountData([]);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const options = {
    margin: 25,
    loop: true,
    responsiveClass: true,
    nav: true,
    dots: false,
    autoplay: false,
    autoplayTimeout: 0,
    autoplayHoverPause: true,
    rewind: false,
    slideBy: 1,
    smartSpeed: 400,
    items: 3,
    stagePadding: 0,
    lazyLoad: true,
    lazyLoadEager: 1,
    responsive: {
      0: {
        items: 1,
        nav: true,
        stagePadding: 0,
      },
      600: {
        items: 2,
        nav: true,
        stagePadding: 0,
      },
      1000: {
        items: 3,
        nav: true,
        stagePadding: 0,
      },
      1200: {
        items: 3,
        nav: true,
        stagePadding: 0,
      },
    },
    // 👇 These are the additions for seamless looping
    center: false, // Ensure it's false unless needed
    autoWidth: false, // Prevent item width from breaking layout
    responsiveRefreshRate: 100, // Faster refresh for responsive updates
    rewind: false, // Keep false to let `loop` handle wrap-around
    checkVisible: false, // Prevent glitch in visibility check
  };

  const handleRedirectVendorProfile = () => {};

  const handleRequestAcces = (row) => {
    setRow(row);
    setIsModalSendInvitationVisible(true);
  };
  function handleCheckBoxChange(checkedValues) {
    setCheckBox(checkedValues.target.value);
    setDisableBtn(false);
  }
  const handleSendInvitationModalCancel = () => {
    setCheckBox("");
    setDisableBtn(false);
    setIsModalSendInvitationVisible(false);
    setPage("RetailerAffirmation");
    setContent("");
  };

  const handleShowEmailWindow = () => {
    setPage("SendEmail");
    handleGetEmailData();
  };

  const handleSendEmail = () => {
    try {
      let inputData = {
        editval: content,
        email_Type: row.emailType,
        vendorID: row.dealerID,
        dealerID: dealerId,
      };
      setLoading(true);
      communityVendorService
        .SendEmailToVendor(inputData)
        .then((response) => {
          setLoading(false);
          var message = response.data.message;

          if (message === "Success") {
            NotificationManager.success(t("Email has been Sent Successfully."));
          } else {
            NotificationManager.error(
              t("Email has not been Sent Successfully.")
            );
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    handleSendInvitationModalCancel();
  };

  const handleNewAccountRequest = () => {
    try {
      let inputData = {
        email_Type: row.emailType,
        vendorID: row.dealerID,
        dealerID: dealerId,
      };
      setLoading(true);
      communityVendorService
        .SendEmailToAllEmailType(inputData)
        .then((response) => {
          setLoading(false);
          var message = response.data.message;

          if (message === "Success") {
            NotificationManager.success(t("Email has been Sent Successfully."));
          } else {
            NotificationManager.error(
              t("Email has not been Sent Successfully.")
            );
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    handleSendInvitationModalCancel();
  };

  const handleGetEmailData = () => {
    try {
      let inputData = {
        vendorID: row.dealerID,

        dealerID: dealerId,
        emailType: row.emailType,
      };
      setEmailLoading(true);
      communityVendorService
        .GeneratePopupForAffirmation(inputData)
        .then((response) => {
          setEmailLoading(false);
          var message = response.data.message;
          var responseData = response.data.responseData.sendMsgBody;
          if (message === "Success") {
            setContent(responseData);
          } else {
            setContent([]);
          }
        })
        .catch((error) => {
          console.log(error);
          setEmailLoading(false);
        });
    } catch (error) {
      console.log(error);
      setEmailLoading(false);
    }
  };

  console.log(recentlyUpdatedVendorData, "recentlyUpdatedVendorData");

  return (
    <React.Fragment>
      <div className="catalog__list">
        {loginDetials.loginDetials.responseData.dealerMemberTypeName !==
          "Vendor" &&
        loginDetials.loginDetials.responseData.dealerMemberTypeName !==
          "VendorDiamond" &&
        loginDetials.loginDetials.responseData.dealerMemberTypeName !==
          "VendorGemstone" ? (
          <div className="row mt-2">
            <div className="col-md-12">
              <Spin spinning={vendorLoading}>
                <div className="slider__section">
                  <CustomCarousel
                    images={recentlyUpdatedVendorData}
                    handleRequestAcces={handleRequestAcces}
                  />
                </div>
              </Spin>
            </div>
          </div>
        ) : null}

        {/* <div className="row">
          <div className="col-md-12">
            <h3 className="subheading"> {t("Category")} </h3>
          </div>
        </div> */}
        <Spin spinning={loading}>
          <div className="row">
            {isDiamondShow ? (
              <div className="col-lg-4 mt-4">
                <div className="whole__block">
                  <div className="top__image">
                    <img src={hoverBg1} className="img-fluid" />
                    <h3> {t("Diamonds")} </h3>
                  </div>
                  <div className="bottom__details">
                    <div className="row">
                      {loginDetials.loginDetials.responseData
                        .dealerMemberTypeName !== "VendorDiamond" &&
                        loginDetials.loginDetials.responseData
                          .dealerMemberTypeName !== "VendorGemstone" &&
                        loginDetials.loginDetials.responseData
                          .dealerMemberTypeName !== "Vendor" && (
                          <div className="col-md-6 col-6">
                            <div className="content__block">
                              <h3 className="count">
                                <AnimatedNumber
                                  value={
                                    Number(
                                      countData.yourTotalDiamonds != null
                                        ? countData.yourTotalDiamonds
                                            .replace(/,/g, "")
                                        : "0"
                                    ) || 0
                                  }
                                />
                              </h3>
                              <h4 className="text"> {t("Total Diamonds")}</h4>
                            </div>
                          </div>
                        )}

                      {loginDetials.loginDetials.responseData
                        .dealerMemberTypeName !== "VendorDiamond" &&
                        loginDetials.loginDetials.responseData
                          .dealerMemberTypeName !== "VendorGemstone" &&
                        loginDetials.loginDetials.responseData
                          .dealerMemberTypeName !== "Vendor" && (
                          <div className="col-md-6 col-6">
                            <div className="content__block">
                              <h3 className="count">
                                <AnimatedNumber
                                  value={
                                    Number(
                                      countData.connectedDiamond != null
                                        ? countData.connectedDiamond
                                            .toString()
                                            .replace(/,/g, "")
                                        : "0"
                                    ) || 0
                                  }
                                />
                              </h3>
                              <h4 className="text">
                                {" "}
                                {t("Connected Diamonds")}{" "}
                              </h4>
                            </div>
                          </div>
                        )}
                      <div
                        style={{ pointer: "cursor" }}
                        className="col-md-6 col-6"
                      >
                        <div
                          style={{ pointer: "cursor" }}
                          className="content__block"
                        >
                          <h3 className="count">
                            <AnimatedNumber
                              value={
                                Number(
                                  countData.yourDiamonds != null
                                    ? countData.yourDiamonds
                                        .toString()
                                        .replace(/,/g, "")
                                    : "0"
                                ) || 0
                              }
                            />
                          </h3>

                          <h4 style={{ pointer: "cursor" }} className="text">
                            {" "}
                            {t("Your Diamonds")}{" "}
                          </h4>
                        </div>
                      </div>

                      <div
                        style={{ pointer: "cursor" }}
                        className="col-md-6 col-6"
                      >
                        <div
                          style={{ pointer: "cursor" }}
                          className="content__block"
                        >
                          <Link to="/viewMyMinedDiamond">
                            <h3 className="count">
                              <AnimatedNumber
                                value={
                                  Number(
                                    countData.minedDiamond != null
                                      ? countData.minedDiamond
                                          .toString()
                                          .replace(/,/g, "")
                                      : "0"
                                  ) || 0
                                }
                              />
                            </h3>
                          </Link>
                          <h4 style={{ pointer: "cursor" }} className="text">
                            {" "}
                            {t("Mined Diamonds")}{" "}
                          </h4>
                        </div>
                      </div>

                      <div
                        style={{ pointer: "cursor" }}
                        className="col-md-6 col-6"
                      >
                        <div
                          style={{ pointer: "cursor" }}
                          className="content__block"
                        >
                          <Link to="/viewMyLabDiamond">
                            <h3 className="count">
                              <AnimatedNumber
                                value={
                                  Number(
                                    countData.labDiamond != null
                                      ? countData.labDiamond
                                          .toString()
                                          .replace(/,/g, "")
                                      : "0"
                                  ) || 0
                                }
                              />
                            </h3>
                          </Link>
                          <h4 style={{ pointer: "cursor" }} className="text">
                            {" "}
                            {t("Lab Diamonds")}{" "}
                          </h4>
                        </div>
                      </div>

                      <div
                        style={{ pointer: "cursor" }}
                        className="col-md-6 col-6"
                      >
                        <div
                          style={{ pointer: "cursor" }}
                          className="content__block"
                        >
                          <Link to="/viewMyColorDiamond">
                            <h3 className="count">
                              <AnimatedNumber
                                value={
                                  Number(
                                    countData.colorDiamond != null
                                      ? countData.colorDiamond
                                          .toString()
                                          .replace(/,/g, "")
                                      : "0"
                                  ) || 0
                                }
                              />
                            </h3>
                          </Link>
                          <h4 style={{ pointer: "cursor" }} className="text">
                            {" "}
                            {t("Color Diamonds")}{" "}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
            {isJewelaryShow ? (
              <div className="col-lg-4 mt-4">
                <div className="whole__block">
                  <div className="top__image">
                    <img src={hoverBg2} className="img-fluid" />
                    <h3> {t("Jewelry")} </h3>
                  </div>
                  <div className="bottom__details">
                    <div className="row">
                      <div
                        style={{ pointer: "cursor" }}
                        className="col-md-6 col-6"
                      >
                        <div
                          style={{ pointer: "cursor" }}
                          className="content__block"
                        >
                          <Link to="/allProducts">
                            <h3 className="count">
                              <AnimatedNumber
                                value={
                                  Number(
                                    countData.totalJewelryProduct != null
                                      ? countData.totalJewelryProduct
                                          .toString()
                                          .replace(/,/g, "")
                                      : "0"
                                  ) || 0
                                }
                              />
                            </h3>
                          </Link>
                          <h4 className="text"> {t("Jewelry")} </h4>
                        </div>
                      </div>
                      <div
                        style={{ pointer: "cursor" }}
                        className="col-md-6 col-6"
                      >
                        <div
                          style={{ pointer: "cursor" }}
                          className="content__block"
                        >
                          <Link to="/myProducts">
                            <h3 className="count">
                              <AnimatedNumber
                                value={
                                  Number(
                                    countData.yourJeweryProducts != null
                                      ? countData.yourJeweryProducts
                                          .toString()
                                          .replace(/,/g, "")
                                      : "0"
                                  ) || 0
                                }
                              />
                            </h3>
                          </Link>
                          <h4 style={{ pointer: "cursor" }} className="text">
                            {" "}
                            {t("Your Products")}{" "}
                          </h4>
                        </div>
                      </div>

                      {loginDetials.loginDetials.responseData
                        .dealerMemberTypeName !== "Vendor" &&
                        loginDetials.loginDetials.responseData
                          .dealerMemberTypeName !== "VendorDiamond" &&
                        loginDetials.loginDetials.responseData
                          .dealerMemberTypeName !== "VendorGemstone" && (
                          <div
                            style={{ pointer: "cursor" }}
                            className="col-md-6 col-6"
                          >
                            <div
                              style={{ pointer: "cursor" }}
                              className="content__block"
                            >
                              <Link to="/sharedProduct">
                                <h3
                                  style={{ pointer: "cursor" }}
                                  className="count"
                                >
                                  <AnimatedNumber
                                    value={
                                      Number(
                                        countData.connectedJewelry != null
                                          ? countData.connectedJewelry
                                              .toString()
                                              .replace(/,/g, "")
                                          : "0"
                                      ) || 0
                                    }
                                  />
                                </h3>
                              </Link>
                              <h4
                                style={{ pointer: "cursor" }}
                                className="text"
                              >
                                {" "}
                                {t("Connected Products")}{" "}
                              </h4>
                            </div>
                          </div>
                        )}

                      <div
                        style={{ pointer: "cursor" }}
                        className="col-md-6 col-6"
                      >
                        <div
                          style={{ pointer: "cursor" }}
                          className="content__block"
                        >
                          <h3 style={{ pointer: "cursor" }} className="count">
                            <AnimatedNumber
                              value={
                                Number(
                                  countData.yourJeweryActiveProducts != null
                                    ? countData.yourJeweryActiveProducts
                                        .toString()
                                        .replace(/,/g, "")
                                    : "0"
                                ) || 0
                              }
                            />
                          </h3>

                          <h4 style={{ pointer: "cursor" }} className="text">
                            {" "}
                            {t("Active Products")}{" "}
                          </h4>
                        </div>
                      </div>

                      <div className="col-md-6 col-6">
                        <div className="content__block">
                          <h3 className="count">
                            {" "}
                            <span style={{ fontSize: "20px", margin: 0 }}>
                              {countData.importType
                                ? countData.importType
                                : "-"}{" "}
                            </span>
                          </h3>
                          <h4 className="text"> {t("Import Type")} </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
            {isWatchShow && (
              <div className="col-lg-4 mt-4">
                <div className="whole__block">
                  <div className="top__image">
                    <img src={hoverBg3} className="img-fluid" />
                    <h3> {t("Watches")} </h3>
                  </div>
                  <div className="bottom__details">
                    <div className="row">
                      <div className="col-md-6 col-6">
                        <div className="content__block">
                          <h3 className="count">
                            <AnimatedNumber
                              value={
                                Number(
                                  countData.yourWatchesProducts != null
                                    ? countData.yourWatchesProducts
                                        .toString()
                                        .replace(/,/g, "")
                                    : "0"
                                ) || 0
                              }
                            />
                          </h3>
                          <h4 className="text"> {t("Your Products")} </h4>
                        </div>
                      </div>

                      <div className="col-md-6 col-6">
                        <div className="content__block">
                          <h3 className="count">
                            <AnimatedNumber
                              value={
                                Number(
                                  countData.connectedWatches != null
                                    ? countData.connectedWatches
                                        .toString()
                                        .replace(/,/g, "")
                                    : "0"
                                ) || 0
                              }
                            />
                          </h3>
                          <h4 className="text"> {t("Connected Products")} </h4>
                        </div>
                      </div>

                      <div className="col-md-6 col-6">
                        <div className="content__block">
                          <h3 className="count">
                            <AnimatedNumber
                              value={
                                Number(
                                  countData.connectedWatches != null
                                    ? countData.connectedWatches
                                        .toString()
                                        .replace(/,/g, "")
                                    : "0"
                                ) || 0
                              }
                            />
                          </h3>
                          <h4 className="text"> {t("Active Products")} </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}{isColorStoneShow ? (
              <div className="col-lg-4 mt-4">
                <div className="whole__block">
                  <div className="top__image">
                    <img src={hoverBg4} className="img-fluid" />
                    <h3> {t("Gemstones")} </h3>
                  </div>
                  <div className="bottom__details">
                    <div className="row">
                      {loginDetials.loginDetials.responseData
                        .dealerMemberTypeName !== "VendorDiamond" &&
                        loginDetials.loginDetials.responseData
                          .dealerMemberTypeName !== "VendorGemstone" &&
                        loginDetials.loginDetials.responseData
                          .dealerMemberTypeName !== "Vendor" && (
                          <div className="col-md-6 col-6">
                            <div className="content__block">
                              <h3 className="count">
                                <AnimatedNumber
                                  value={
                                    Number(
                                      countData.yourTotalColorStones != null
                                        ? countData.yourTotalColorStones
                                            .replace(/,/g, "")
                                        : "0"
                                    ) || 0
                                  }
                                />
                              </h3>
                              <h4 className="text"> {t("Total Gemstones")}</h4>
                            </div>
                          </div>
                        )}

                      {loginDetials.loginDetials.responseData
                        .dealerMemberTypeName !== "VendorDiamond" &&
                        loginDetials.loginDetials.responseData
                          .dealerMemberTypeName !== "VendorGemstone" &&
                        loginDetials.loginDetials.responseData
                          .dealerMemberTypeName !== "Vendor" && (
                          <div className="col-md-6 col-6">
                            <div className="content__block">
                              <h3 className="count">
                                <AnimatedNumber
                                  value={
                                    Number(
                                      countData.connectedColorStone != null
                                        ? countData.connectedColorStone
                                            .toString()
                                            .replace(/,/g, "")
                                        : "0"
                                    ) || 0
                                  }
                                />
                              </h3>
                              <h4 className="text">
                                {" "}
                                {t("Connected Gemstones")}{" "}
                              </h4>
                            </div>
                          </div>
                        )}
                      <div
                        style={{ pointer: "cursor" }}
                        className="col-md-6 col-6"
                      >
                        <div
                          style={{ pointer: "cursor" }}
                          className="content__block"
                        >
                          <h3 className="count">
                            <AnimatedNumber
                              value={
                                Number(
                                  countData.yourColorStones != null
                                    ? countData.yourColorStones
                                        .toString()
                                        .replace(/,/g, "")
                                    : "0"
                                ) || 0
                              }
                            />
                          </h3>

                          <h4 style={{ pointer: "cursor" }} className="text">
                            {" "}
                            {t("Your Gemstones")}{" "}
                          </h4>
                        </div>
                      </div>

                      <div
                        style={{ pointer: "cursor" }}
                        className="col-md-6 col-6"
                      >
                        <div
                          style={{ pointer: "cursor" }}
                          className="content__block"
                        >
                          <Link to="/viewMyGemstone">
                            <h3 className="count">
                              <AnimatedNumber
                                value={
                                  Number(
                                    countData.colorStone != null
                                      ? countData.colorStone
                                          .toString()
                                          .replace(/,/g, "")
                                      : "0"
                                  ) || 0
                                }
                              />
                            </h3>
                          </Link>
                          <h4 style={{ pointer: "cursor" }} className="text">
                            {" "}
                            {t("Gemstones")}{" "}
                          </h4>
                        </div>
                      </div>

                      
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </Spin>
      </div>
      <Modal
        title={
          page == "RetailerAffirmation"
            ? t("Retailer Affirmation")
            : t("Send Email")
        }
        visible={isModalSendInvitationVisible}
        className="forgot__password"
        onCancel={handleSendInvitationModalCancel}
        footer={[
          //
          <div className={page == "RetailerAffirmation" ? "d-block" : "d-none"}>
            <Button
              key="submit"
              className={checkbox == "" ? "disabled-btn" : "primary-btn"}
              disabled={(checkbox == "") == true ? true : false}
              onClick={
                checkbox == "CurrentAuthorizedReseller"
                  ? handleShowEmailWindow
                  : handleNewAccountRequest
              }
            >
              {t("Submit")}
            </Button>
          </div>,
          <div className={page == "SendEmail" ? "d-block" : "d-none"}>
            <Button
              className="primary-btn"
              key="submit"
              onClick={handleSendEmail}
            >
              {t("Send")}
            </Button>
          </div>,
        ]}
      >
        <div className="form__fields p-0 border-0 mh-auto">
          {page == "RetailerAffirmation" ? (
            <div>
              {category.map((item) => {
                return (
                  <Fragment>
                    <div className="radio__block">
                      <Checkbox
                        key={item.value}
                        onChange={handleCheckBoxChange}
                        checked={item.value == checkbox}
                        value={item.value}
                        id={item.value}
                      >
                        <label htmlFor={item.value}> {t(item.label)} </label>
                      </Checkbox>
                    </div>
                    <div>
                      <p> {item.note} </p>
                    </div>
                  </Fragment>
                );
              })}
            </div>
          ) : (
            <div className="editor__section">
              <Spin spinning={emailLoading}>
                <CKEditor
                  editor={ClassicEditor}
                  data={content}
                  // config={editorConfiguration}
                  onReady={(editor) => {
                    // You can store the "editor" and use when it is needed.
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setContent(data);
                  }}
                />
              </Spin>
            </div>
          )}
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default CatlogList;
